const PASSWORD_ALLOWED_CHARS = "[a-zA-Z0-9!=+_$:;^/()~?.¬%*\"#&',-<>@`\\\\\\][{|} ‘’“”]";
const WEAK_PASSWORD_CHARS = "(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])";
const STRONG_PASSWORD_CHARS = "(?=.*?[$&+,:;=?@#|'<>.^*()%!\\-_/=~¬\"`\\\\\\][{} ‘’“”])";

export const validationRegex = {
	uppercase: "[A-Z]",
	lowercase: "[a-z]",
	alphanumeric: "^[a-zA-Z0-9]*$",
	number: "^[0-9]*$",
	realNumber: "^[0-9]*\\.?[0-9]*$",
	currencyAmount: "^([0-9]*\\.[0-9]{1,2}|[0-9]*)$", // no decimal point or max 2 decimal places.
	numberNotZero: "^[1-9]\\d*$",
	noNumber: "^([^0-9]*)$",
	noUppercase: "^([^A-Z]*)$",
	noLowercase: "^([^a-z]*)$",
	passwordSpecialChars: "[$@!%*?&()~;:_+=.]",
	passwordAllowedChars: `^(${PASSWORD_ALLOWED_CHARS}*)$`,
	email:
		"^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~])+" +
		"(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~])+)*)" +
		"|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x7f]|\\x21|" +
		"[\\x23-\\x5b]|[\\x5d-\\x7e])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]" +
		"))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]" +
		"|\\d)|(([a-z]|\\d)([a-z]" +
		"|\\d|-||_|~)*([a-z]|\\d)))" +
		"\\.)+(([a-z])+|(([a-z])+" +
		"([a-z]+|\\d|-|\\.{0,1}|_|~)?([a-z])))$",
	username: "^([^\\s]+)$",
	passwordStrength: {
		// min 8 chars (1 low, 1 number, 1 upper)
		weak: new RegExp(`^${WEAK_PASSWORD_CHARS}${PASSWORD_ALLOWED_CHARS}{8,}$`),
		// min 8 (1 low,1 upp,1 number,1 spec)
		medium: new RegExp(`^${WEAK_PASSWORD_CHARS}${STRONG_PASSWORD_CHARS}${PASSWORD_ALLOWED_CHARS}{8,}$`),
		// min 10 (1 low,1 upp,1 number,1 spec)
		strong: new RegExp(`^${WEAK_PASSWORD_CHARS}${STRONG_PASSWORD_CHARS}${PASSWORD_ALLOWED_CHARS}{10,}$`),
	},
	nationalId: {
		coga: "^[0-9]*$",
		cogaTransitionPeriod: "^\\d{6,8}$|^\\d{10}$",
		georgia: "^[a-zA-Z0-9-]*$",
		sga: "^\\d{6}(\\d{2})?[+-]?\\d{4}$",
		hgc: "^[a-zA-Z0-9Ά-ωΑ-ώ-]*$",
	},
	newNationalId: {
		hgc: "^[A-Z]{1,2}\\d{7,8}$",
	},
	phoneNumber: {
		tr: "^5\\d{9}$",
	},
	ascii: "^[\x00-\x7f]+$",
	latinLetters: "^[a-zA-Z]*$",
	dateDDMMYYYY: "^\\d{1,2}\\/\\d{1,2}\\/\\d{4}$",
	cepNumber: new RegExp("^\\d{5}\\-\\d{3}$"),
	cpfNumber: "^\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}$",
	latinWithHyphen: "^([a-zA-Z]+(-[a-zA-Z]+)?(-[a-zA-Z]+)?)$",
};
